import React, { memo, useCallback, useEffect, useState } from "react";
import {
  OutlinedDropdown,
  type DropdownOption,
} from "@bloomberg/media-ui-dropdown";
import styles from "./style.module.css";
import Datepicker from "~components/Datepicker";
import { getBfixDateString } from "~utils/section-front/getBfixDateString";
import { useLocale } from "~hooks/i18n/useLocale";
import { BFIX_LOCATIONS } from "~constants";

const MemoizedOutlinedDropdown = memo(OutlinedDropdown);

const [firstSuggestion] = BFIX_LOCATIONS;

type BfixHeaderProps = {
  onBfixDateChange: (value: { bfixDateString: string } | undefined) => void;
};

export default function BfixHeader({ onBfixDateChange }: BfixHeaderProps) {
  const { isJapanese } = useLocale();
  const [rateDate, setRateDate] = useState<Date>(new Date());
  const [region, setRegion] = useState<DropdownOption>(firstSuggestion);

  const handleTimeChange = useCallback(
    (selectedValue: DropdownOption | null) => {
      if (selectedValue) {
        setRegion(selectedValue);
      }
    },
    [setRegion]
  );

  const handleDateChange = useCallback(
    (selectedValue: Date) => {
      if (selectedValue) {
        setRateDate(selectedValue);
      }
    },
    [setRateDate]
  );

  // Refresh rates when region or date changes
  useEffect(() => {
    // get BFIX date string based on selected region and selected date
    const dateString = getBfixDateString(
      rateDate,
      region.time,
      region.timezone
    );

    onBfixDateChange({ bfixDateString: dateString });
  }, [onBfixDateChange, rateDate, region]);

  const today = new Date();

  return (
    <div className={styles.bfixHeader}>
      <div className={styles.wrapper}>
        <MemoizedOutlinedDropdown
          className={styles.regionDropdown}
          onChange={handleTimeChange}
          inputProps={{ autocomplete: "off" }}
          options={BFIX_LOCATIONS}
          size="small"
          value={region}
        />
      </div>
      <div className={styles.wrapper}>
        <Datepicker
          className={styles.datePicker}
          label=""
          isJapanese={isJapanese}
          maxDate={today}
          native={false}
          value={rateDate.getTime()}
          onChange={handleDateChange}
          variant="refresh-2025"
        />
      </div>
    </div>
  );
}
